<template>
    <el-row>
        <el-form label-width="120px" ref="MachineForm">
            <el-col :span="8">
                <el-form-item label="厂家品牌:">
                    <el-input size="mini" v-model="MachineInfo.brand"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="仪器型号:">
                    <el-input size="mini" v-model="MachineInfo.type"></el-input>
                </el-form-item>
            </el-col>

        </el-form>
    </el-row>
</template>

<script>
    import {mapActions} from 'vuex'
    export default {
        name: "InputMachineInfo",
        data() {
            return {
                MachineInfo: {
                    brand: '',
                    type: ''
                },
                ...mapActions('sepaMethods', ['updateMachineInfo'])
            }
        },
        methods:{
            resetForm(){
                this.MachineInfo= {
                    brand: '',
                    type: ''
                }
            },
        },
        created() {
          this.MachineInfo = this.$store.state.sepaMethods.MachineInfo;
        },
        watch: {
            'machineInfo' : {
                handler() {
                    this.updateMachineInfo(this.machineInfo)
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>